// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAboutForm_wrapper__GxgJo","submitWrapper":"EditAboutForm_submitWrapper__Vtj+1"};